import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {Customer} from "../api";

export class CustomerService extends RestService<Customer> {
    constructor(url: string) {
        url ? super(url) : super(REST_API_END_POINTS.CUSTOMERS)
    }
}
